import axios from 'axios';
import keycloak from '../../../keycloack';

export default function setup() {
    axios.interceptors.request.use(function(config) {
       // if(navigator.onLine){
            const userToken = window.localStorage.getItem('userToken')
            const token = userToken? userToken.replace(/"/g, '') : false;
            if(token && !config.headers.Authorization) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        // } else {
        //     location.href = '/#/login'
        // }
    }, function(err) {
        return Promise.reject(err);
    });
    axios.interceptors.response.use(function (response) {
        if(response.status === 401) {
            // keycloak.updaterefreshtoken()
            console.log("Token Expired")
            keycloak.logoutWithoutTokenId()
            // Promise.reject("You are not authorized");
        }
        return response;
    }, (error) => {
        if (error.response && error.response.data && error.response.data.attributes && (error.response.data.statusCode == 401 || error.response.data.attributes.reason == "invalid token (expired)") ) {
            // keycloak.updaterefreshtoken()
            // console.log("Token Expired")
            // keycloak.logoutWithoutTokenId()
            // return Promise.reject(error.response.data);
        }
        return error;
    });
};



// WEBPACK FOOTER //
// ./src/modules/shared/interceptors/interceptor.js